<template>
    <v-container class="fill-height" fluid>
        <v-flex style="padding-top: 90px">
            <v-layout row justify-center>
                <v-flex xs12 sm8 md6 lg4 xl4 class="pa-10">
                    <v-card class="elevation-4 pa-8 pt-0 mx-auto">
                        <v-form ref="form" lazy-validation @submit.prevent="signup">
                            <v-card-text>
                                <v-card width="150" height="150" class="pa-8 mx-auto round-card" color="#FEC74E">
                                    <v-layout justify-center>
                                        <v-img src="../assets/logo.png" max-width="100" max-height="100">
                                        </v-img>
                                    </v-layout>
                                </v-card>
                                <v-flex>
                                    <div class="headline text-center pa-4 font-weight-black primary--text">DAFTAR</div>
                                    
                                    <v-col cols="12">
                                        <v-text-field label="Username" v-model="user.username" :rules="requiredRules" required></v-text-field>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-text-field
                                        id="password"
                                        label="Password"
                                        name="password"                                    
                                        :rules="requiredRules"                           
                                        :append-icon="show1 ? 'mdi-eye-off' : 'mdi-eye'"
                                        :type="show1 ? 'text' : 'password'"
                                        @click:append="show1 = !show1"
                                        v-model="user.password"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-text-field
                                        id="confirmPassword"
                                        label="Confirm Password"
                                        name="confirm_password"     
                                        :rules="passwordRules"                           
                                        :append-icon="show2 ? 'mdi-eye-off' : 'mdi-eye'"
                                        :type="show2 ? 'text' : 'password'"
                                        @click:append="show2 = !show2"
                                        v-model="user.confirm_password"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-text-field label="Nama Lengkap" :rules="requiredRules" v-model="user.nama_lengkap" required></v-text-field>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-text-field label="Kelas" :rules="requiredRules" v-model="user.kelas" required></v-text-field>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-text-field label="Nama Sekolah" :rules="requiredRules" v-model="user.sekolah"></v-text-field>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-text-field
                                        label="Kota / Kab"
                                        required v-model="user.kota" :rules="requiredRules"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-text-field label="Alamat Email" :rules="requiredEmailRules" v-model="user.email" required></v-text-field>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-text-field label="No. HP" v-model="user.no_hp"></v-text-field>
                                    </v-col>
                                </v-flex>
                            </v-card-text>
                            <v-card-actions>
                                <v-layout justify-center wrap>
                                    <v-btn type="submit" block rounded color="primary" class="font-weight-bold" :disabled="loading" :loading="loading" x-large>Daftar</v-btn>
                                    <div class="ma-7 mb-0 light-grey--text caption text-center">Sudah mempunyai akun?<v-btn text x-small class="text-none font-weight-bold text-center" color="primary" to="/login">Login disini</v-btn></div>
                                </v-layout>
                            </v-card-actions>
                        </v-form>
                    </v-card>
                    <v-dialog v-model="dialog" persistent max-width="290">
                        <v-card>
                            <v-card-title class="headline">Berhasil</v-card-title>
                            <v-card-text>{{ message }}</v-card-text>
                            <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="green darken-1" text to="login">Login</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                    
                    <v-layout row class="lighter-grey--text caption font-weight-thin text-center mt-10" justify-center>Copyright {{ new Date().getFullYear() }} © Grafindo Media Pratama. All Right Reserved.</v-layout>
                </v-flex>
            </v-layout>
        </v-flex>
    </v-container>
</template>

<script>
import * as api from '@/api'
  export default {
    props: {
      source: String,
    },
    data: () => ({
      drawer: null,
      loading: false,
      message: '',
      messages: {},
      error: false,
      user: {},
      requiredRules: [
        v => !!v || 'Field ini wajib diisi',
      ],
      requiredEmailRules: [
          v => !!v || 'Field ini wajib diisi',
          v => /.+@.+/.test(v) || "Email harus valid",
      ],
      show1: false,
      show2: false,
      dialog: false
    }),
    computed: {
        passwordRules() {
            return [
                () => (this.user.password === this.user.confirm_password) || 'Password tidak cocok',
                v => !!v || 'Field ini wajib diisi'
            ];
        },
    },
    methods: {
        async signup(event){
            event.preventDefault()
            if (this.$refs.form.validate()) {
                this.loading = true
                this.error = false
                this.message = ''
                this.messages = {}
                
                await api.post('auth/register', this.user, async (res) => {
                    if(res.status){
                        if(res.data.status){
                            this.dialog = true
                            this.message = res.data.message || 'Registrasi berhasil! Silakan login.'
                            this.$store.commit('SHOW_SNACKBAR', { text: this.message, color: 'success' })
                            this.loading = false
                        } else {
                            this.message = res.data.message || 'Terjadi kesalahan'
                            this.$store.commit('SHOW_SNACKBAR', { text: this.message, color: 'error' })
                            this.error = true
                            this.loading = false
                        }
                    } else {
                        if (res.data && res.data.errors) {
                            this.messages = res.data.errors
                            const errorTexts = []
                            if (res.data.errors.username) errorTexts.push(...res.data.errors.username)
                            if (res.data.errors.email) errorTexts.push(...res.data.errors.email)
                            this.$store.commit('SHOW_SNACKBAR', { text: errorTexts.join(', ') || 'Terjadi kesalahan validasi', color: 'error' })
                        } else {
                            this.message = res.data.message || 'Terjadi kesalahan'
                            this.$store.commit('SHOW_SNACKBAR', { text: this.message, color: 'error' })
                        }
                        this.error = true
                        this.loading = false
                    }
                })
            }
        }
    }
  }
</script>

<style>
    .round-card{
        border-radius: 100px !important;
        margin-top: -90px;
    }
</style>